export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/_plushshopping/",
  twitter: "https://x.com/_plushshopping",
  tiktok: "https://www.tiktok.com/@_plushshopping",
};

export const ACCESS_TOKEN_KEY = "plush-access-token";
